export default {"src":"/_next/static/media/BBY.60bac08f.svg","height":18,"width":18};